import { CustomError } from '../error/custom-error.js';

export function getOrCreate<T>(
  map: { [key: string]: T },
  key: string,
  create: () => T,
): T {
  const existing = map[key];
  if (existing === undefined) {
    const value = create();
    map[key] = value;
    return value;
  }
  return existing;
}

export function setIfEmpty<T>(
  map: { [key: string]: T },
  key: string,
  value: T,
) {
  const existing = map[key];
  if (existing) {
    throw new CustomError('key already exists', { key });
  }
  map[key] = value;
}
